
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"b"}},[_c('path',{attrs:{"d":"M0 0h32v32H0z"}})]),_c('filter',{attrs:{"id":"a","x":"0%","y":"0%","width":"100%","height":"100%"}},[_c('feColorMatrix',{attrs:{"in":"SourceGraphic","values":"0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"}})]),_c('mask',{attrs:{"id":"c"}},[_c('g',{attrs:{"filter":"url(#a)"}},[_c('path',{attrs:{"fill-opacity":".4","d":"M0 0h32v32H0z"}})])]),_c('g',{attrs:{"id":"d","clip-path":"url(#b)"}},[_c('path',{attrs:{"d":"M25.266 24.625c2.203-2.398 3.309-5.273 3.309-8.625 0-2.648-.735-5.05-2.207-7.2-1.422-2.152-3.309-3.698-5.66-4.652v.676c0 .852-.32 1.602-.958 2.25-.636.602-1.37.903-2.207.903h-3.086v3.222c0 .45-.171.825-.515 1.125-.293.301-.66.45-1.102.45H9.75V16h9.41c.442 0 .81.149 1.106.45.293.3.442.675.442 1.124v4.801h1.543c1.468 0 2.476.75 3.015 2.25zm-10.809 4.05v-3.073c-.836 0-1.57-.329-2.207-.977s-.957-1.398-.957-2.25v-1.574l-7.5-7.652c-.242 1-.367 1.953-.367 2.851 0 3.25 1.054 6.074 3.164 8.477 2.156 2.398 4.777 3.797 7.867 4.199zM4.898 4.75C7.984 1.6 11.688.023 16 .023S23.99 1.601 27.031 4.75c3.086 3.101 4.63 6.851 4.63 11.25s-1.544 8.176-4.63 11.324c-3.043 3.101-6.718 4.652-11.03 4.652s-8.016-1.55-11.103-4.652C1.86 24.175.34 20.398.34 16S1.86 7.85 4.898 4.75z"}})])]),_c('use',{attrs:{"mask":"url(#c)","xlink:href":"#d"}})])
          )
        }
      }
    